import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { ShohiyoData } from '@/models/ShohiyouKoumoku';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class ShohiyouService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();
    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getSeibiShohiyou() {
        const { result, error } = await this.commonService.get(`${this.baseAPI}/seibi-shohiyou`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getSeibiShohiyou');
        }
    }

    public async getShohiyouKoumoku(id?: number) {
        const { result, error } = await this.commonService.get(id
            ? `${this.baseAPI}/shohiyou-koumoku/${id}`
            : `${this.baseAPI}/shohiyou-koumoku/`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getShohiyouKoumoku');
        }
    }

    public async editShohiyouKoumoku(data: ShohiyoData) {
        const { defDispKbn } = data;
        const { result, error } = await this.commonService.put(`${this.baseAPI}/shohiyou-koumoku/`, {
            ...data,
            defDispKbn: defDispKbn ? 1 : 0,
        });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editShohiyouKoumoku');
        }
    }

    public async deleteShohiyouKoumoku(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/shohiyou-koumoku/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteShohiyouKoumoku');
        }
    }

    public async saveShohiyouKoumoku(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/shohiyou-koumoku/`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveShohiyouKoumoku');
        }
    }

    public async saveOrder(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/shohiyou-koumoku-order-display `, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async getShohiyouKoumokuExtension(id?: number) {
        const { result, error } = await this.commonService.get(`${this.baseAPI}/shohiyou-koumoku-extension/${id}`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getShohiyouKoumoku');
        }
    }

    public async saveShohiyouKoumokuExtension(id: number, data: any[]) {
        const url = `${this.baseAPI}/shohiyou-koumoku-extension/${id}`;
        const { result, error } = await this.commonService.put(url, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveShohiyouKoumoku');
        }
    }

}
